import Details from './Details';
import Docs from './Docs';
import Logo from './Logo';
import FormCalculatorStyling from './FormCalculatorStyling';
import Limits from './Limits';
import Links from './Links';
import Action from './Action';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../../store/selectors/products';

const Wrapper = () => {
  const { data } = useSelector(selectProduct);
  const {
    isActive,
    visibility: { isLimitFormVisible, isFormAndCalculatorVisible },
  } = data;

  return (
    <div className='integration__content'>
      <div className='integration__content--wrapper'>
        <Details />
      </div>

      <div className='integration__content--wrapper'>
        <Docs />
      </div>

      <div className='integration__content--wrapper'>
        <Logo />
      </div>

      {isFormAndCalculatorVisible && (
        <div className='integration__content--wrapper'>
          <FormCalculatorStyling />
        </div>
      )}

      {isLimitFormVisible && (
        <div className='integration__content--wrapper'>
          <Limits />
        </div>
      )}

      <Action />

      {isActive && <Links />}
    </div>
  );
};

export default Wrapper;
